/* eslint-disable no-confusing-arrow */
const { formatImage, formatUrl } = require('@ifeng-fe/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleAreaAd: data => {
        return data === '0' ? '' : data;
    },
    handleLastRecommend: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 222, 156) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
};
